import React, { createContext, PureComponent } from 'react';

interface IModalControl {
  open: () => void;
  close: () => void;
}

interface IState {
  isOpen: boolean;
}

export default function createModalContext() {
  const ModalControlContext = createContext<IModalControl | undefined>(undefined);

  const IsModalOpenContext = createContext<boolean>(false);

  class ModalProvider extends PureComponent<unknown, IState> {
    public readonly state: IState = {
      isOpen: false,
    };

    private readonly control: IModalControl = {
      open:  () => this.setState({ isOpen: true }),
      close: () => this.setState({ isOpen: false }),
    };

    public render() {
      const {
        state: { isOpen },
        props: { children },
        control,
      } = this;

      return (
        <ModalControlContext.Provider value={control}>
          <IsModalOpenContext.Provider value={isOpen}>
            {children}
          </IsModalOpenContext.Provider>
        </ModalControlContext.Provider>
      );
    }
  }

  return {
    ModalProvider,
    GetModalControl: ModalControlContext.Consumer,
    IsModalOpen:     IsModalOpenContext.Consumer,
  };
}
